// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-configuration-explorer{
    position: absolute;
    top: 20px;
    right: 20%;
    width: 100%;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
}
.device-configuration-explorer-header{
    margin: 0px;
    padding: 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
}
.device-configuration-explorer-header h3{
    margin: 0px;
    color: white;
    font-weight: lighter;
}
.device-configuration-explorer-header p{
    margin: 0px;
    color: white;
    font-size: 20px;
    cursor: pointer;
}
.add-new-configuration-button{
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    padding: 2px 4px;
    margin-right: 20px;
}
.add-new-configuration-button:hover{
    background-color: rgb(214, 214, 214);
}
.add-new-configuration-button img{
    height: 30px;
}
.device-configuration-explorer-body{
    height: 50vh;
    overflow-y: auto;
    padding: 10px 20px;
    padding-left: 30px;
}
.device-configuration-explorer-summary-table{
    width: 100%;
}
.device-configuration-explorer-summary-table th{
    text-align: left;
}
.device-configuration-explorer-summary-table button{
    border: none;
    cursor: pointer;
    background-color: transparent;
}
.device-configuration-explorer-summary-table td img{
    height: 20px;
}
.device-configuration-explorer-summary-table-control-buttons-container{
    display: flex;
    justify-content: space-around;
    padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Devices/ConfigurationExplorer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB","sourcesContent":[".device-configuration-explorer{\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20%;\r\n    width: 100%;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\r\n    border-radius: 10px;\r\n}\r\n.device-configuration-explorer-header{\r\n    margin: 0px;\r\n    padding: 15px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n}\r\n.device-configuration-explorer-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-weight: lighter;\r\n}\r\n.device-configuration-explorer-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n.add-new-configuration-button{\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    padding: 2px 4px;\r\n    margin-right: 20px;\r\n}\r\n.add-new-configuration-button:hover{\r\n    background-color: rgb(214, 214, 214);\r\n}\r\n.add-new-configuration-button img{\r\n    height: 30px;\r\n}\r\n.device-configuration-explorer-body{\r\n    height: 50vh;\r\n    overflow-y: auto;\r\n    padding: 10px 20px;\r\n    padding-left: 30px;\r\n}\r\n.device-configuration-explorer-summary-table{\r\n    width: 100%;\r\n}\r\n.device-configuration-explorer-summary-table th{\r\n    text-align: left;\r\n}\r\n.device-configuration-explorer-summary-table button{\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n}\r\n.device-configuration-explorer-summary-table td img{\r\n    height: 20px;\r\n}\r\n.device-configuration-explorer-summary-table-control-buttons-container{\r\n    display: flex;\r\n    justify-content: space-around;\r\n    padding-right: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
